import { useEffect, useRef, useState } from "react";
import ReviewStarBar from "./ReviewStarBar";
import { retrieveData } from "../apis/dataService";

function ReviewBar() {
    const [ReviewsArray , setReviewsArray] = useState([])
    useEffect(()=>{
        retrieveData({
            api: '/reviews-form',
            var: 'RatingStars'
          })
            .then(data => {
              setReviewsArray(data)
            })
            .catch(error => {
              console.error('Error in fetchData:', error);
            });
    },[])
    return (
        <div className="ReviewBar">
            <div className="ReviewBar-heading">
                Customer Rating Overview
            </div>
            <div className="ReviewBars">
                <ReviewStarBar star='5' Reviews={ReviewsArray}/>
                <ReviewStarBar star='4' Reviews={ReviewsArray}/>
                <ReviewStarBar star='3' Reviews={ReviewsArray}/>
                <ReviewStarBar star='2' Reviews={ReviewsArray}/>
                <ReviewStarBar star='1' Reviews={ReviewsArray}/>
            </div>
        </div>
    );
}

export default ReviewBar;